<script>
import { saveState, getSavedState } from '@utils/browser-help'
import { authComputed } from '@state/helpers'
import filterArrayByValue from '@utils/filter-array-by-value'
import { groupByKey } from '@utils'
import cloneDeep from 'lodash/cloneDeep'
import TheHeader from './TheHeader'
import menuList from './sidemenu'

export default {
  components: { TheHeader },
  props: {
    isNoTop: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      current: ['home'],
      collapsed: true,
      // collapsed: getSavedState('collapsed') !== null ? getSavedState('collapsed') : true,
      menus: [],
      lockDialogVisible: false,
      width: 0,
      appStyle: process.env.VUE_APP_BUILD_MODE === 'admin-app-build',
      openMenu: false
    }
  },
  watch: {
    /* async collapsed(value){
      await saveState('collapsed',value)
      // saveState('collapsed',value)
    } */
  },
  computed: {
    ...authComputed,
    userMenuList() {
      const menuListClone = cloneDeep(menuList)
      const userMenu = filterArrayByValue(this.initModuleTab(menuListClone), this.currentUserRoutes, 'name')
      return groupByKey(userMenu, 'group')
    },
    externalURL() {
      return window.location.hostname.includes('daydream-lab') ? 'https://shop.jtails.daydream-lab.com/jtails_dashboard/' : 'http://shop.j-tails.com/jtails_dashboard/'
    },
    isMobileStaffMode() {
      return this.currentUserRoutes.includes('employee-calendar') && /Mobi/.test(navigator.userAgent)
    }
  },
  mounted() {
    const appDirection = window.matchMedia('(orientation: landscape)')
    const initCollapsed = async () => {
      // const stateCollapsed = await getSavedState('collapsed') ?? true;

      // this.collapsed = stateCollapsed !== null ? stateCollapsed : true
      // await this.setCollapsed(stateCollapsed)
    };

    if (!this.isMobileStaffMode) {
      this.handleOrientationChange(appDirection)
      appDirection.addListener(this.handleOrientationChange)
    }

    this.handleWidth()
    window.addEventListener('resize', this.handleWidth)
    initCollapsed();
    this.openMenu = window.innerWidth >= 576 ? true : false
  },
  methods: {
    /**
     * @description 初始化模組
     */
     initModuleTab(menuList) {
      // 如果沒有買daycare，就filter掉daycare
      if (!this.$hasDayCare()) {
        menuList = menuList.filter(item => item.name !== 'daycare')
      }
      return menuList
    },
    typeChange(value) {
      if (value === 'true') {
        return true
      } else {
        return false
      }
    },
    async toggle() {
      await this.setCollapsed(!this.collapsed)
    },
    handleWidth() {
      const appDirection = window.matchMedia('(orientation: landscape)')
      if (window.innerWidth <= 1024) {
        this.handleOrientationChange(appDirection)
      }
      if (window.innerWidth >= 576) {
        this.openMenu = true
      }
    },
    handleOrientationChange(screenDirection) {
      this.lockDialogVisible = !screenDirection.matches && window.innerWidth <= 1024
    },
    openWidthMenu() {
      if (window.innerWidth < 576) {
        this.openMenu = !this.openMenu
      }
    }
    // async setCollapsed(value) {
    //   this.collapsed = value;
    //   await saveState('collapsed', value)
    // }
    /* getWindowWidth(){
      this.width = window.innerWidth
    } */
  },
}
</script>

<template>
  <div :class="[$style.wrapper, { [$style['wrapper--collapsed']]: !collapsed }]">
    <template v-if="loggedIn">
      <div :class="[$style.sidebar, { [$style.isCollapsed]: !collapsed }]">
        <el-menu mode="vertical" :collapse="false" :class="$style.menu" :collapse-transition="false">
          <el-menu-item :class="[$style['menu__item'], openMenu ? $style['openSideBar'] : $style['closeSideBar']]"
            class="isLogo" @click="openWidthMenu">
            <BaseIcon name="bars" icon-style="far" />
          </el-menu-item>
          <div v-for="(group, groupNumber) in userMenuList" :key="groupNumber" :class="$style['menu__group']">
            <router-link v-for="menu in group" :key="menu.name" :to="{ name: menu.name }" :class="$style['menu__link']"
              :style="{ height: `${100 / group.length}%` }">
              <el-menu-item class="d-flex flex-column justify-content-center"
                :class="[$style['menu__item'], openMenu ? $style['openSideBar'] : $style['closeSideBar']]"
                :welcome-guide-title="menu.title" :welcome-guide-intro="menu.description">
                <img :src="require(`@assets/images/icons/${menu.icon}`)" alt="" :width="menu.iconSize">
                <span v-if="openMenu" slot="title" class="mt-3 mx-0">{{ menu.title }}</span>
              </el-menu-item>
            </router-link>
          </div>
        </el-menu>
      </div>
      <div :class="[$style.content]">
        <TheHeader />
        <el-main :class="[$style.main, { 'no-top': isNoTop }, appStyle ? $style.appBaseTop : '']">
          <slot name="pageTitle" />
          <slot />
        </el-main>
      </div>
    </template>

    <el-main v-else :class="$style.main">
      <slot />
    </el-main>
    <!-- <el-dialog
        title="網站以橫向模式瀏覽最佳"
        :visible.sync="lockDialogVisible"
        top="0"
        width="680px"
        :show-close="false"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        center
        lock-scroll
      >
        <p style="text-align: center;">請旋轉您的裝置</p>
      </el-dialog> -->
  </div>
</template>

<style lang="scss" module>

.menu__group {
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
  height: 100%;
  // margin-bottom: 20px;
}

.sidebar {
  position: absolute;
  z-index: $layer-sidebar-z-index;
  height: 100%;
  background-color: $color-sidebar-bg;
  transition: width 0.3s;
  top: 0;
  left: 0;
  z-index: 9999;
  // margin-top: -1px;
  overflow-y: auto;

  &:before {
    content: '';
    background-color: $color-secondary;
    width: 100%;
    height: constant(safe-area-inset-top);
    height: env(safe-area-inset-top);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }

  &.isCollapsed {
    &:before {
      background-color: #FDD7AA !important;
    }
  }



  @include max-sm {
    // width: 180px;
    width: auto;
    background-color: transparent;
    pointer-events: none;
  }

  .menu {
    display: flex;
    flex-direction: column;
    // justify-content: space-between;
    // height: calc(100% - #{$size-header-height});
    // height: 100%;
    background-color: $color-sidebar-bg;
    border-right: none;
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);
    position: relative;
    height: 100%;
    // margin-left: -1px;

    @media only screen and (max-width: 1025px) {
      overflow-y: scroll;
    }

    @include max-sm {
      height: 100%;
      pointer-events: auto;
    }

    &::before,
    &::after {
      display: none;
    }

    &__item {
      color: white;
      height: 100%;
      line-height: 1;
      align-items: center;
      font-size: 12px;
      font-weight: 300;

      :global {
        .el-tooltip {
          height: auto !important;
          position: relative !important;
          padding: 0 !important;
        }
      }

      &:global {
        &.isLogo {
          background: $color-primary;
          display: flex;
          justify-content: center;
          align-items: center;

          &:hover {
            background: $color-primary;
          }

          svg {
            font-size: 2rem;
          }
        }
      }

      svg {
        // margin-left: 5px;
        // margin-right: 10px;
      }

      &:hover {
        background: $color-secondary-light;
      }

      &:focus {
        background: $color-secondary-light;
      }

      i {
        color: white;
      }
    }

    &__itemText {
      @include max-sm {
        // display: none;
      }
    }

    &__link {
      height: 100%;
      // max-height: 72px;
      text-decoration: none;

      &:global(.router-link-active) .menu__item {
        background: $color-secondary-light;
      }
    }
  }
}

.openSideBar {
  width: 72px;
}

.closeSideBar {
  width: 55px;
}

.content {
  margin-left: $size-sidebar-width;

  @include max-sm {
    margin-left: $size-sidebar-width-iphone !important;
  }
}

.wrapper {
  &--collapsed {
    .sidebar {
      // width: 180px;
      width: auto;

      @include max-sm {
        // width: 100vw;
      }
    }

    .content {
      margin-left: 72px;

      @include max-sm {
        margin-left: $size-sidebar-width;
      }

      // @include max-sm {
      //   width: 55px !important;
      // }
    }
  }
}

.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  height: $size-header-height;
  background: $color-secondary;

  // border:$color-primary 1px solid;
  // width: 65px;
  // width: 65px;
  img {
    // height: $size-header-height - 20px;
    height: 60px;
  }
}

.main:global(.el-main) {
  position: relative;
  padding-top: $size-header-height + 30px;
  padding-top: calc(constant(safe-area-inset-top) + #{$size-header-height} + 30px);
  padding-top: calc(env(safe-area-inset-top) + #{$size-header-height});
  // padding-left: 25px;
  // padding-right: 25px;
  overflow: initial;

  @include max-sm {
    padding-top: $size-header-height;
    padding-top: calc(constant(safe-area-inset-top) + #{$size-header-height});
    padding-top: calc(env(safe-area-inset-top) + #{$size-header-height});
  }

  &.appBaseTop {
    :global {

      .el-tabs.isStyleBase,
      .isStyleBaseLine {
        top: 84px !important;
      }

      .isSecond {
        top: 140px !important;
      }
    }
  }
}
</style>
